import { closeSplitViewCalendarButtonTooltip } from './ContentHeader.locstring.json';
import loc, { format } from 'owa-localize';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { ControlIcons } from 'owa-control-icons';
import { IconButton } from 'office-ui-fabric-react/lib/Button';

const styles = require('./ContentHeader.scss');

/**
 * ContentHeader properties
 */
export interface ContentHeaderProps {
    text: string;
    colorScheme: ColorScheme;
    onClick: () => void;
    forwardedRef: (element: HTMLElement) => void;
}

/**
 * Content header for calendar views in split mode
 */
export const ContentHeader = observer(function ContentHeader(props: ContentHeaderProps) {
    let { text, colorScheme, onClick, forwardedRef } = props;
    return (
        <div
            ref={forwardedRef}
            className={styles.contentHeaderContainer}
            style={{ color: colorScheme.accessibleText.msColorWhiteBackground }}>
            <div className={styles.contentName}>{text}</div>
            <IconButton
                iconProps={{ iconName: ControlIcons.Cancel }}
                onClick={onClick}
                title={format(loc(closeSplitViewCalendarButtonTooltip), text)}
            />
        </div>
    );
});
